

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://c183baa23371454f99f417f6616b724d@sentry.wixpress.com/5557", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/642234fd4b5a8fad/packages/bookings-my-bookings-widget/src/components/MyBookings/Widget/index.tsx';
    import createController from '/home/builduser/work/642234fd4b5a8fad/packages/bookings-my-bookings-widget/src/components/MyBookings/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'MyBookings';
    var projectName = 'bookings-my-bookings-widget';
    var sentryConfig = {
      DSN: 'https://c183baa23371454f99f417f6616b724d@sentry.wixpress.com/5557',
      id: 'undefined',
      projectName: 'bookings-my-bookings-widget',
      teamName: 'bookings',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/642234fd4b5a8fad/packages/bookings-my-bookings-widget/src/components/MyBookings/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["wix-bookings-client","wix-bookings-visitor"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/642234fd4b5a8fad/packages/bookings-my-bookings-widget/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"app.my-bookings-widget.dummy.staff-member":"Staff Member","app.my-bookings-widget.dummy.service-name":"Service Name","app.my-bookings-widget.dummy.service-address":"Service Address","app.my-bookings-widget.header.title":"Manage Your Bookings","app.my-bookings-widget.header.subtitle":"View, reschedule or cancel your bookings and easily book again.","app.my-bookings-widget.timezone-dropdown.label":"Time Zone:","app.my-bookings-widget.upcoming-tab.label":"Upcoming","app.my-bookings-widget.history-tab.label":"History","app.my-bookings-widget.empty-state.no-upcoming-bookings.label":"You've got nothing booked at the moment.","app.my-bookings-widget.empty-state.no-upcoming-bookings.button.label":"Check Out Our Services","app.my-bookings-widget.manage-actions.button.label":"Manage","app.my-bookings-widget.empty-state.no-history-bookings.label":"We’re looking forward to meeting you.","app.my-bookings-widget.empty-state.no-history-bookings.button.label":"Check Out Our Services","app.my-bookings-widget.book-another.button.label":"Book another","app.my-bookings-widget.book-cancel.label":"Cancel","app.my-bookings-widget.book-reschedule.label":"Reschedule","app.my-bookings-widget.join-video-conference.link.label":"Join Zoom meeting","app.my-bookings-widget.join-video-conference.copy.tooltip":"Copy link","app.my-bookings-widget.join-video-conference.copy.success-text":"Link Copied!","app.my-bookings-widget.view-service-details.link.label":"View service details","app.my-bookings-widget.bookings-list.group-limit-indication-label":"Only last {limit} bookings are displayed","app.my-bookings-widget.bookings-details.duration.days":"{days} {days, plural, one {day} other {days}}","app.my-bookings-widget.bookings-details.duration.hours":"{hours} {hours, plural, one {hr} other {hrs}}","app.my-bookings-widget.bookings-details.duration.minutes":"{minutes} {minutes, plural, one {min} other {mins}}","app.my-bookings-widget.bookings-details.course-starts":"Starts on {date}","app.my-bookings-widget.bookings-details.course-started-on":"Started on {date}","app.my-bookings-widget.bookings-details.pending-approval":"Pending Approval","app.my-bookings-widget.bookings-details.waitlist":"Waitlist","app.my-bookings-widget.bookings-details.available-online":"Available Online","app.my-bookings-widget.cancellation-modal-with-reschedule.title":"Are you sure you want to cancel your session?","app.my-bookings-widget.cancellation-modal-with-reschedule.content":"You can change the date and time if you'd like to reschedule.","app.my-bookings-widget.cancellation-modal-with-reschedule.primary-button.label":"Cancel Session","app.my-bookings-widget.cancellation-modal-with-reschedule.secondary-button.label":"Reschedule","app.my-bookings-widget.cancellation-modal.title":"Cancel Booking","app.my-bookings-widget.cancellation-modal.content":"Are you sure you want to cancel { serviceName }?","app.my-bookings-widget.cancellation-modal.primary-button.label":"Yes","app.my-bookings-widget.cancellation-modal.secondary-button.label":"No","app.my-bookings-widget.group-cancellation-modal.title":"Are you sure you want to cancel this appointment?","app.my-bookings-widget.group-cancellation-modal.content":"if you cancel this service, the entire appointment along with any other services will also be cancelled.","app.my-bookings-widget.group-cancellation-modal.primary-button.label":"Cancel Appointment","app.my-bookings-widget.group-cancellation-modal.secondary-button.label":"Keep Appointment","app.my-bookings-widget.cancellation-modal.toast-error-message.label":"Your booking wasn't cancelled due to a technical issue. Refresh and try again.","app.my-bookings-widget.cancellation-modal.toast-success-message.label":"Booking cancelled.","app.my-bookings-widget.reschedule-modal.title":"Contact us to reschedule","app.my-bookings-widget.reschedule-modal.content":"This service was booked in an appointment with other services. You'll need to let us know if you'd like to reschedule.","app.my-bookings-widget.reschedule-modal.primary-button.label":"OK","app.my-bookings-widget.booking-content.staff-prefix":"with {staffName}","app.my-bookings-widget.booking-content.number-of-participants-prefix":"No. of participants {numOfParticipants}","app.settings.tabs.main":"Main","app.settings.tabs.design":"Design","app.settings.tabs.text":"Text","app.settings.design.general.text-style-title":"Text Style","app.settings.design.general.page-title":"Page title","app.settings.design.general.page-subtitle":"Page subtitle","app.settings.font-picker.title":"Choose your font","app.settings.tabs.design.tabs.general":"General","app.settings.tabs.design.tabs.with-bookings":"With Bookings","app.settings.tabs.design.tabs.no-bookings":"No Bookings","app.settings.tabs.text.tabs.general":"General","app.settings.tabs.text.tabs.no-bookings":"No Bookings","app.settings.text.general.page-header-actions":"Actions","app.settings.text.general.upcoming-tab.title":"Upcoming Tab","app.settings.text.general.history-tab.title":"History Tab","app.settings.text.general.page-title":"Title","app.settings.text.general.page-subtitle":"Subtitle","app.settings.text.general.video-conference.section-header":"Video Conferencing","app.settings.text.general.video-conference.show-video.checkbox":"Show video conferencing link","app.settings.text.general.video-conference.meeting-link.text":"Open Meeting Link","app.settings.main-tab.customize-cta":"Customize","app.settings.main-tab.content":"Members can see, cancel and reschedule their bookings here.","app.settings.reset-to-original-design":"Reset to original design"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "13d21c63-b5ec-5912-8397-c3a5ddb27a97";
    var componentId = "261fd12d-a3ac-4ee8-8913-09eceb8b1d3e";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/642234fd4b5a8fad/packages/bookings-my-bookings-widget/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
